export default new class PhoneController {
    unformat(phone = "0 (000) 000-0000") {
        if (!phone) return "";
        phone = phone.replaceAll("(", "");
        phone = phone.replaceAll(")", "");
        phone = phone.replaceAll("-", "");
        phone = phone.replaceAll(" ", "");
        phone = phone.replaceAll("+", "");
        return phone;
    }

    forPhoneBox(event) {
        let phone = event.target.value;
        if (!phone) return phone;
        return this.format(this.unformat(phone));
    }

    format(phone = "0000000000") {
        let unformat = this.unformat(phone);
        if (unformat.length === 10) unformat = "1" + unformat;

        const len = unformat.length;
        let p0 = unformat.slice(0, len - len - 10);
        let p1 = unformat.slice(len - 10, len - 7);
        let p2 = unformat.slice(len - 7, len - 4);
        let p3 = unformat.slice(len - 4, len);
        return `+${p0} (${p1}) ${p2}-${p3}`
    }

    toDisplay(phone = "0000000000") {
        let unformat = this.unformat(phone);
        if (unformat.length === 10) unformat = "1" + unformat;
        const len = unformat.length;
        let p1 = unformat.slice(len - 10, len - 7);
        let p2 = unformat.slice(len - 7, len - 4);
        let p3 = unformat.slice(len - 4, len);
        return `(${p1}) ${p2}-${p3}`
    }

}();
